import React, { useState, useEffect } from "react"
// import { ConfigurationContext } from 'containers/ConfigurationProvider'
// import { getDefaultLang } from 'utils/theming'

const initialContextShape = {
  rtl: false,
  t: Function.prototype,
  lang: "",
  doneAt: 0,
}

export const I18nContext = React.createContext(initialContextShape)

// const vv = "user {name}"

const I18nProvider = ({ children, lang = "en" }) => {
  const i18nState = {
    rtl: lang === "ar",
    t: Function.prototype,
    lang,
    doneAt: 0,
  }
  const [i18n, setI18n] = useState(() => i18nState)

  const fetchMessages = React.useCallback(async lang => {
    try {
      const response = await fetch(`/langs/${lang}.json`)
      const messages = await response.json()
      const rtl = lang === "ar"
      setI18n(_s => ({
        t: k => messages[k] || k,
        lang,
        rtl,
        doneAt: Date.now(),
      }))
    } catch (e) {
      console.log({ ErrorWhileFetchingMessages: e })
    }
  }, [])

  useEffect(() => {
    fetchMessages(lang)
  }, [lang, fetchMessages])

  const contextValue = React.useMemo(() => {
    return i18n
    //eslint-disable-next-line
  }, [i18n.doneAt])

  return (
    <I18nContext.Provider value={contextValue}>{children}</I18nContext.Provider>
  )
}

export function useI18n() {
  const i18n = React.useContext(I18nContext)
  return i18n
}

export default I18nProvider
